import { makeStyles } from "tss-react/mui"
import { Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { DeadlineMessageInfo } from "../shop/delivery/deliveryApi"
import { ConfirmModal } from "../../../dialogs/ConfirmModal"

const useStyles = makeStyles()((theme) => ({
    messageBox: {
        color: theme.palette.tailwind.blue[950],
        background: theme.palette.tailwind.sky[100],
        padding: "1rem",
        borderRadius: ".25rem",
        textAlign: "left",
        marginTop: "1rem",
    },
    message: {
        textAlign: "left",
        color: theme.palette.tailwind.slate[950],
    },
    classNameOverride: {
        padding: "1.25rem 1.5rem 3.25rem",
    },
}))

type DeadlineMessageDialogProps = Readonly<{
    onClose: () => void
    message: DeadlineMessageInfo
    handlePlaceOrder: () => void
}>

export function DeadlineMessageDialog({ onClose, message, handlePlaceOrder }: DeadlineMessageDialogProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict
            id="create-order-delivery-deadline-message-dialog-title"
            attrs={{ title: !message.title, buttonLabelCancel: true, buttonLabelSubmit: true }}
        >
            <ConfirmModal
                open={!!message}
                onClose={onClose}
                title={message.title ?? "Deadline has been exceeded"}
                message={
                    <Stack gap="2rem">
                        <Stack gap="1rem" className={classes.messageBox}>
                            <Typography variant="subtitle1">{message.displayRule}</Typography>
                            <LocalizedStrict id="create-order-delivery-deadline-message-dialog-description">
                                <Typography>
                                    You can still place the order, but the order needs to be approved by the staff,
                                    which means you can not expect the order to be delivered.
                                </Typography>
                            </LocalizedStrict>
                        </Stack>
                        <Typography className={classes.message}>{message.merchantMessage}</Typography>
                    </Stack>
                }
                handleClick={handlePlaceOrder}
                buttonLabelCancel="Cancel order"
                buttonLabelSubmit="Place order"
                autoCloseAfterSubmit={false}
                maxWidthProp="lg"
                buttonColorSubmit="black"
                classNameOverride={classes.classNameOverride}
            />
        </LocalizedStrict>
    )
}
